import React from "react";
import PropTypes from "prop-types";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

const QuestionTypeDropdown = ({
  label,
  value,
  onChange,
  width = "140px",
  size = "small",
  placeholder = "Select Type",
  showIcons = true,
}) => {
  const questionTypes = [
    {
      value: "",
      label: "All Types",
      icon: null,
    },
    {
      value: "VERBAL",
      label: "VERBAL",
      icon: "🎤",
      color: "#1976d2", // info color
    },
    {
      value: "WRITTEN",
      label: "WRITTEN",
      icon: "✏️",
      color: "#9c27b0", // secondary color
    },
  ];

  return (
    <ArgonBox display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
      {/* Label */}
      {label && (
        <ArgonTypography variant="subtitle2" fontWeight="medium" color="text" mr={1}>
          {label}
        </ArgonTypography>
      )}

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: width,
          minHeight: size === "small" ? "40px" : "48px",
          padding: "8px 40px 8px 12px",
          borderRadius: "8px",
          border: "1px solid #d4d4d4",
          cursor: "pointer",
          backgroundColor: "rgba(0,0,0,0.02)",
          outline: "none",
          color: value ? "#344767" : "#7b809a",
          fontWeight: "500",
          fontSize: size === "small" ? "14px" : "16px",
          fontFamily: "inherit",
          transition: "all 0.2s ease-in-out",
          appearance: "none",
          backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23999' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 12px center",
          backgroundSize: "12px",
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#1976d2";
          e.target.style.boxShadow = "0 0 0 2px rgba(25, 118, 210, 0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#d4d4d4";
          e.target.style.boxShadow = "none";
        }}
      >
        {questionTypes.map((type) => (
          <option
            key={type.value}
            value={type.value}
            style={{
              backgroundColor: "white",
              color: "#344767",
              padding: "8px",
              fontSize: "14px",
            }}
          >
            {showIcons && type.icon ? `${type.icon} ${type.label}` : type.label}
          </option>
        ))}
      </select>
    </ArgonBox>
  );
};

QuestionTypeDropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(["small", "medium"]),
  placeholder: PropTypes.string,
  showIcons: PropTypes.bool,
};

QuestionTypeDropdown.defaultProps = {
  label: null,
  width: "140px",
  size: "small",
  placeholder: "Select Type",
  showIcons: true,
};

export default QuestionTypeDropdown;
